import React, { Component } from "react";
import IconButton from "material-ui/IconButton";
import Menu, { MenuItem } from "material-ui/Menu";
import MoreVertIcon from "material-ui-icons/MoreVert";
import _ from "lodash";
import { Link } from "react-router";

class StudyGroupsItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { group, navigateToGroup } = this.props;

    const is_checked = _.includes(this.props.studygroup_ids, group.id);
    const ITEM_HEIGHT = 48;
    const { anchorEl } = this.state;

    return (
      <tr>
        <td>
          {!(
            new Date(group.start_date) <= new Date() &&
            new Date(group.end_date) >= new Date()
          ) && (
            <p>
              <input
                type="checkbox"
                className="filled-in"
                id={`filled-in-box-${group.id}`}
                checked={is_checked}
                onChange={() => this.props.checkedStudygroupIds(group.id)}
              />
              <label htmlFor={`filled-in-box-${group.id}`} />
            </p>
          )}
        </td>
        <td>
          <Link to={`/groups/${group.id}/webinars`}>
            {group.title || "New Group"}
          </Link>
        </td>
        <td>
          {(group.superhosts || []).map((superhost) => (
            <p key={superhost.id}>{superhost.email}</p>
          ))}
        </td>
        <td>
          <IconButton
            className="table_more"
            aria-label="More"
            aria-owns={anchorEl ? "long-menu" : null}
            aria-haspopup="true"
            onClick={this.handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: 200,
              },
            }}
          >
            <Link to={`/groups/${group.id}/edit`}>
              <MenuItem>Edit</MenuItem>
            </Link>
          </Menu>
        </td>
      </tr>
    );
  }
}

StudyGroupsItem.defaultProps = {};

StudyGroupsItem.propTypes = {};

export default StudyGroupsItem;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/List/StudyGroupsItem.jsx